import {
  AuthorizationList,
  CanAccess,
} from "../../components/template/authorization/Authorization";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import { Link } from "react-router-dom";
import AppRoutePath from "../../router/AppRoutePath";
export const initFilterInput = {
  searchName: "",
  page: 1,
  pageSize: 10,
};

export const renderColumns = (handleEdit, handleDelete) => {
  return [
    {
      dataIndex: "area",
      key: "area",
      title: "Nama Provinsi",
      render: (text) => (
        <div
          style={{
            textTransform: "capitalize",
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "total_kota",
      key: "total_kota",
      title: "Jumlah Kota / Kabupaten",
    },
    {
      dataIndex: "total_kecamatan",
      key: "total_kecamatan",
      title: "Jumlah Kecamatan",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div className="col-1 d-flex justify-content-center flex-row">
          <div className="mr-2">
            <CanAccess
              role={AuthorizationList.create_area}
              yes={
                <Link
                  to={{
                    pathname: AppRoutePath.EDIT_AREA_LIST.replace(":id", record.id),
                  }}
                >
                  <BiEditAlt
                    onClick={() => handleEdit(record)}
                    style={{
                      fontSize: 24,
                      color: "#F5CB58",
                      cursor: "pointer",
                    }}
                  />
                </Link>
              }
            />
          </div>

          <CanAccess
            role={AuthorizationList.delete_area}
            yes={
              <div className="mr-2" onClick={() => handleDelete(record)}>
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color: "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
        </div>
      ),
    },
  ];
};
